export class RemitToModel {
    public GPVID:string;
    public RemitToCompanyName: string;
    public RemitToContactPerson: string;
    public RemitToContactEmail: string;
    public RemitToContactFax: string;
    public RemitToContactPhone: string;
    public RemitToAddress1: string;
    public RemitToAddress2: string;
    public RemitToCity: string;
    public RemitToState: string;
    public RemitToZipCode: string;
    public RemitToCountry: string;
    public RemitToCurrency: string;
}


// WEBPACK FOOTER //
// ./src/app/models/RemitTo.ts